import AdminCategoryPageEditor from "@/components/admin/AdminCategoryPageEditor";
export default function AdminAktivitasJamaah() {
  return <AdminCategoryPageEditor pageKey="aktivitas-jamaah" pageTitle="Halaman: Aktivitas Jamaah" previewPath="/kategori/aktivitas-jamaah" />;
}
